<app-window-title
  [closable]="true"
  [title]="title"
  (closed)="onClose()"></app-window-title>

<div
  class="search-dialog-content"
  fxLayout="column"
  mat-dialog-content>
  <!-- HUB MERGE CASES BADGE -->
  <div
    *ngIf="canViewMergeCases && pendingMergeCaseCount > 0"
    class="merge-cases-banner"
    fxLayout="row"
    fxLayoutAlign="start center"
    fxLayoutGap="8px"
    (click)="onClose(); router.navigate(['/hub/merge-cases'])">
    <mat-icon>warning_amber</mat-icon>
    <span>
      <strong>{{ pendingMergeCaseCount }}</strong>
      pending DICOM merge {{ pendingMergeCaseCount === 1 ? 'case' : 'cases' }} — Review
    </span>
    <mat-icon>arrow_forward</mat-icon>
  </div>

  <!-- SEARCH INPUT -->
  <div class="search-section">
    <div class="search-row">
      <mat-form-field
        appearance="outline"
        subscriptSizing="fixed"
        class="search-field">
        <mat-label> Search {{ Labels.clientMatterLabel }} </mat-label>
        <input
          #searchClientsInput
          cdkFocusInitial
          matInput
          [value]="caseName"
          (input)="caseName = searchClientsInput.value"
          (keyup)="search($event)" />
      </mat-form-field>
      <button
        color="warn"
        mat-icon-button
        matTooltip="Search"
        class="search-button"
        (click)="search($event)">
        <mat-icon>search</mat-icon>
      </button>
      <button
        color="warn"
        mat-icon-button
        matTooltip="Refresh"
        class="refresh-button"
        (click)="getFilesSharedWith()">
        <mat-icon>refresh</mat-icon>
      </button>
    </div>
    <div class="search-hint">Search by name, medical record number or date of birth</div>
  </div>

  <!-- NO RESULTS -->
  <div
    *ngIf="!ownerNeeded && !searchResult?.length"
    class="no-results fx-jc-center fx-ai-center"  >
    <p>No patients found</p>
  </div>

  <!-- RESULTS -->
  <div
    *ngIf="searchResult?.length > 0"
    class="results-section">
    <div
      class="results-header fx-row fx-jc-start fx-ai-center fx-gap-8"  >
      <mat-icon class="results-icon"> people </mat-icon>
      <span class="results-count">
        <strong>{{ searchResult.length }}</strong>
        {{ searchResult.length === 1 ? 'patient' : 'patients' }} found
      </span>
    </div>

    <div
      class="results-list fx-col fx-gap-6"  >
      <div
        *ngFor="let patient of searchResult; trackBy: trackByClientId"
        class="client-item">
        <div (click)="dialogdata ? handleSelectClient(patient) : routeToProfile(patient)">
          <app-client-list-item
            [client]="patient"
            [hasNotifications]="patient.hasNotifications"
            [permissions]="{ dialogdata: false, ableToEditClient: ableToEditClient }"
            (editClient)="editClient($event)">
          </app-client-list-item>
        </div>
        <app-auto-forwarding-section
          *ngIf="isHubStaff && patient.caseName && currentFacility"
          [caseName]="patient.caseName"
          [hubFacilityId]="currentFacility">
        </app-auto-forwarding-section>
      </div>
    </div>
  </div>
</div>
